import api from '../../api/index.js'

const state = {
    
}

const getters = {

}

const actions = {
    UpdateNickName({commit},payload) {
        return new Promise((resolve, reject) => {
            api.post('/Member/UpdateNickName',payload, res => {
                commit({
                    type: "setMember",
                    res: res,
                })
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    },
    UpdatePassword({commit},payload) {
        return new Promise((resolve, reject) => {
            api.post('/Member/UpdatePassword',payload, res => {
                commit({
                    type: "setLogout",
                    res: res,
                })
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    },
    UpdatePhone({commit},payload) {
        return new Promise((resolve, reject) => {
            api.post('/Member/UpdatePhone',payload, res => {
                commit({
                    type: "setMember",
                    res: res,
                })
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    },
}

const mutations = {
    setLogout(state, payload) {
        localStorage.removeItem("token");
        localStorage.removeItem("member");
        state.isLogin = false;
    },
    setMember(state, payload) {
        if(payload.res.result.status) {
            localStorage.removeItem("member");
            localStorage.setItem("member",JSON.stringify(payload.res.result.data.member));
        }
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js